import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { DistanceEventExtraField } from '@/types/api/calendar'


export default /*#__PURE__*/_defineComponent({
  __name: 'DistancePresentation',
  props: {
    eventExtraField: null
  },
  setup(__props: any) {

const props = __props as { eventExtraField: DistanceEventExtraField };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(props.eventExtraField.name) + ": " + _toDisplayString(props.eventExtraField.distance) + " " + _toDisplayString(props.eventExtraField.unit), 1))
}
}

})